import {
  currentAndLegacyReportsByEntityId,
  getSavedViewsByReportIdWithLimit,
  savedViewsByReportId,
  IEntity
} from '@opengov/api-deprecated';

import { ICurrentOrLegacySavedView } from './types';

import { generateV1SavedViewUrl, generateV2SavedViewUrl } from './utils';

interface IGetCurrentOrLegacySavedViewsParams {
  reportId?: string;
  reportVersion: string;
  legacyReportId?: string;
  entity?: IEntity;
}

export * from './types';

export async function getCurrentOrLegacyReportsByEntityId(e: {
  entityId: number;
  includeAccountSummaryReports?: boolean;
  includeMultiDatasetReports?: boolean;
}) {
  return currentAndLegacyReportsByEntityId({
    entityId: e.entityId,
    includeAccountSummaryReports: e.includeAccountSummaryReports,
    includeMultiDatasetReports: e.includeMultiDatasetReports
  });
}

export async function getV2ReportSavedViews(
  e: IGetCurrentOrLegacySavedViewsParams
): Promise<ICurrentOrLegacySavedView[]> {
  return savedViewsByReportId({ reportId: e.reportId }).then((views) =>
    views.map((savedView) => ({
      id: savedView.id,
      name: savedView.title,
      description: savedView.description,
      reportId: savedView.reportId,
      url: generateV2SavedViewUrl(e.entity.subdomain, savedView.reportConfiguration, savedView.reportId, savedView.id)
    }))
  );
}

// Used for legacy saved views
export async function getV1ReportSavedViewsWithLimit(
  e: IGetCurrentOrLegacySavedViewsParams
): Promise<ICurrentOrLegacySavedView[]> {
  return getSavedViewsByReportIdWithLimit({ report_id: e.legacyReportId, limit: 5000 }).then((savedViews) => {
    return savedViews.map((sv) => ({
      ...sv,
      name: sv.description,
      description: null,
      reportId: e.legacyReportId,
      id: sv.uuid,
      legacySavedViewId: sv.id,
      url: generateV1SavedViewUrl(sv, e.entity)
    }));
  });
}

export async function getCurrentOrLegacySavedViews(
  e: IGetCurrentOrLegacySavedViewsParams
): Promise<ICurrentOrLegacySavedView[]> {
  return e.reportVersion && e.reportVersion === 'v2' ? getV2ReportSavedViews(e) : getV1ReportSavedViewsWithLimit(e);
}
